/* file description */
import { getModuleRecordList } from '@/common/asset-apis/assetModel';

const getAssetRecord = async ({ FetchAPI, resultParams, params }: any) => {
  const parmasData = {
    page: params.current,
    ...resultParams,
  };

  const { namespaceID, moduleID } = resultParams;
  const result = await getModuleRecordList(FetchAPI, namespaceID, moduleID, parmasData);
  return result;
};

export default getAssetRecord;
